"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ShopifyIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_835_6)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.761.371l-1.02 3.597s-1.153-.5-2.522-.4c-2.013.125-2.013 1.3-2.013 1.599.108 1.599 4.643 1.948 4.911 5.72.188 2.973-1.69 4.996-4.4 5.146-3.275.2-5.073-1.599-5.073-1.599l.698-2.748S5.14 12.96 6.589 12.86c.94-.05 1.288-.774 1.261-1.274-.134-2.098-3.837-1.973-4.079-5.42C3.583 3.27 5.623.321 10.131.071c1.745-.125 2.63.3 2.63.3z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_835_6"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h16v16H0z"
  })))))
});
ShopifyIcon.displayName = 'ShopifyIcon';
var _default = exports.default = ShopifyIcon;